import React, { PureComponent } from 'react';

// import field data
import { incomeRequired } from './data';

// import components
import {
  CalcTitle,
  CalcFieldRow,
  CalcField,
  CalcError,
  CalcInput,
  CalcLabel,
  CalcWrapper,
  CalcButton,
  CalcResultsWrapper,
  CalcResultsContainer,
} from './styled';

class IncomeRequired extends PureComponent {
  state = {
    values: { loanAmount: '', interestRate: '', loanTerm: '', tax: '', debt: '' },
    errors: { loanAmount: '', interestRate: '', loanTerm: '', tax: '', debt: '' },
    income: 0,
    calculated: false,
  };

  drawFields = fields => {
    return fields.map(field => {
      const { config, label, name, validators } = field;
      return (
        <CalcField key={name}>
          <CalcInput
            {...config}
            type="text"
            aria-labelledby={name}
            name={name}
            id={name}
            value={this.state.values[name]}
            onChange={e => this.handleChange(e, validators)}
            required
          />
          <CalcLabel htmlFor={name}>{label}</CalcLabel>
          {this.state.errors[name] ? (
            <CalcError className="error">{this.state.errors[name]}</CalcError>
          ) : (
            <CalcError>&nbsp;</CalcError>
          )}
        </CalcField>
      );
    });
  };

  handleChange = (e, validators) => {
    const { name, value } = e.target;

    const updateObj = { ...this.state.values };

    updateObj[name] = value;

    // validators.forEach(validator => {
    //   this[validator](value, name);
    // });

    this.setState({ values: updateObj });
  };

  calculateIncome = () => {
    const {
      values: { loanAmount, interestRate, loanTerm, tax, debt },
    } = this.state;

    const principal = loanAmount.replace('$', '').replace(/,/g, '');
    const rate = interestRate.replace('%', '').replace(/ /g, '') / 100 / 12;
    const term = loanTerm.replace(' years', '') * 12;

    console.log(principal, rate, term);

    const numerator = rate * Math.pow(1 + rate, term);
    const denominator = Math.pow(1 + rate, term) - 1;
    const payment = principal * (numerator / denominator);

    const annualPayment = payment * 12;
    const annualDebt = debt.replace('$', '').replace(/,/g, '') * 12;
    const annualTax = parseInt(tax.replace('$', '').replace(/,/g, ''));

    const income = ((annualPayment + annualDebt + annualTax) / 0.44)
      .toFixed(2)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    this.setState({
      income,
      calculated: true,
    });

    return income;
  };

  render() {
    const { calculated, income } = this.state;
    return (
      <>
        <CalcTitle>Calculate How Much You Need to Earn to Afford Your Dream Home</CalcTitle>
        <CalcFieldRow>{this.drawFields(incomeRequired)}</CalcFieldRow>
        <CalcWrapper>
          <CalcButton onClick={() => this.calculateIncome()}>Calculate</CalcButton>
        </CalcWrapper>
        {calculated ? (
          <CalcResultsWrapper>
            <CalcResultsContainer>
              <div>
                <h3>Required Salary</h3>
                <h5>${income}</h5>
              </div>
            </CalcResultsContainer>
          </CalcResultsWrapper>
        ) : null}
      </>
    );
  }
}

export default IncomeRequired;
